import * as React from 'react';
import { SVGProps } from 'react';

const FileIconLoadingSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 28" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect width={24} height={28} rx={2} />
  </svg>
);
export default FileIconLoadingSizeS;
